export default import.meta.ROLLDOWN_FILE_URL_Msg57USEadASvSStYSdmzA_45449de4e698d4f383044feb